import React from 'react'
import {
  formatValidity,
  contentAPIRequestHandler,
} from 'components/AppHome/utils'
import update from 'immutability-helper'
import { BaseForm } from 'components/Form'
import { withRouter } from 'react-router-dom'
import Module from 'components/OmniJourney/X4ULayout/Module'
import ModuleForm from 'components/AppHome/AppLayout/ModuleForm'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { formatModuleValues, ErrorDialog } from 'components/OmniJourney/utils'
import SelectModuleTypePopup from 'components/OmniJourney/X4ULayout/SelectModuleTypePopup'
import Mapping from 'components/OmniJourney/X4ULayout/Mapping'
import classNames from '../../../../lib/utils/classNames'
import { APP_PAGES } from 'components/Engage/utils'
import { getMessage } from 'lib/translator'
import Loader from 'components/Loader'
import './style.scss'

const Layout = ({
  layout,
  setTab,
  onReset,
  moveCard,
  canReset,
  setPopUp,
  onUpdateLayout,
  setCurrentModule,
  setCurrentModuleIndex,
}) => {
  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }
    moveCard(result.source.index, result.destination.index)
  }

  return (
    <div className="layout-section">
      {canReset && (
        <div className="layout-header">
          <button
            type="button"
            className="button secondary undo-button"
            onClick={onReset}
          >
            Reset
          </button>
          <button
            type="button"
            className="button primary"
            onClick={onUpdateLayout}
          >
            Update layout
          </button>
        </div>
      )}
      <DragDropContext onDragEnd={onDragEnd}>
        {layout.length > 0 ? (
          <Droppable droppableId="droppable">
            {(provided) => (
              <div
                className="layout-list"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {layout.map((module, index) => {
                  const key = `${module.type}-${index}`
                  return (
                    <Draggable key={key} draggableId={key} index={index}>
                      {(itemProvided) => (
                        <div
                          ref={itemProvided.innerRef}
                          {...itemProvided.draggableProps}
                          {...itemProvided.dragHandleProps}
                          style={{
                            ...itemProvided.draggableProps.style,
                          }}
                        >
                          <Module
                            index={index}
                            module={module}
                            setCurrentModule={setCurrentModule}
                            setCurrentModuleIndex={setCurrentModuleIndex}
                            setTab={setTab}
                          />
                        </div>
                      )}
                    </Draggable>
                  )
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        ) : (
          <div className="no-modules-section">
            <p>{getMessage('omni-journey.no.module')}</p>
          </div>
        )}
      </DragDropContext>
      <div className="add-module-section">
        <button
          type="button"
          className="button primary add-module-button"
          data-testid="add-module-button"
          onClick={() => setPopUp('module-type')}
        >
          <span className="icon">+</span>
          <span className="text">{getMessage('omni-journey.add.module')}</span>
        </button>
      </div>
    </div>
  )
}

class X4ULayoutForm extends BaseForm {
  constructor(props) {
    super(props)

    this.state = {
      values: {
        startTime: '00:00:00',
        endTime: '00:00:00',
        scanRule: {
          type: 'default',
        },
        layout: [],
        isDisabled: true,
      },
      isLoading: false,
      originalLayout: null,
      currentModule: null,
      currentModuleIndex: null,
      showErrorDialog: false,
      errorMessage: null,
      formType: 'layout',
      activeTab: 0,
      popUp: null,
    }
  }

  moveCard = (dragIndex, hoverIndex) => {
    this.setState((prevState) => {
      const layout = prevState.values.layout || []
      const dragItem = layout[dragIndex]
      const reorderedLayout = update(layout, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragItem],
        ],
      })

      // Save original layout only on first move
      const originalLayout =
        prevState.originalLayout || JSON.parse(JSON.stringify(layout))

      return {
        originalLayout,
        values: {
          ...prevState.values,
          layout: reorderedLayout,
        },
      }
    })
  }

  undoLastMove = () => {
    this.setState((prevState) => {
      const { originalLayout, values } = prevState
      if (!originalLayout) {
        return null
      }

      return {
        originalLayout: null,
        values: {
          ...values,
          layout: JSON.parse(JSON.stringify(originalLayout)),
        },
      }
    })
  }

  async componentDidMount() {
    if (this.props.method === 'edit') {
      this.setState({ isLoading: true })
      const apiData = this.props.apiData.data.items[0]
      const layout = apiData.layout.map((module) =>
        formatModuleValues(module, 'api')
      )
      const validity = await formatValidity('api', apiData)
      const values = {
        ...apiData,
        ...validity,
        layout,
      }

      this.setState({
        values,
        isLoading: false,
      })
    }
  }

  setPopUp = (popUp) => this.setState({ popUp })

  setCurrentModule = (currentModule) => this.setState({ currentModule })

  setCurrentModuleIndex = (currentModuleIndex) =>
    this.setState({ currentModuleIndex })

  handleTabChange = (activeTab) => this.setState({ activeTab })

  _submitHandler = async (
    e,
    saveAsDraft = false,
    moduleAction = null,
    moduleValues = null
  ) => {
    e && e.preventDefault()
    this.setState({ pressedSubmitWithCurrentData: true })
    if (!this.isFormValid()) {
      this.setState({
        errorMessage: getMessage(
          'omni-journey.error-msg.incomplete-invalid-form'
        ),
        showErrorDialog: true,
      })
      return
    }

    this.setState({ isLoading: true })
    const { action } = this.props.router.match.params
    const req = action !== 'add' ? 'PUT' : 'POST'
    const callbacks = {
      onCancel: () => {},
      onError: ({ message }) =>
        this.setState({
          isLoading: false,
          errorMessage: message,
          showErrorDialog: true,
        }),
      onSuccess: this.props.onCancel,
    }
    const { startTime, endTime } = await formatValidity(
      'form',
      this.state.values
    )

    const payload = {
      data: {
        ...this.state.values,
        endTime,
        startTime,
        isDisabled: saveAsDraft,
      },
      contentType: 'scan',
      key: 'layout#profile',
    }

    const SCAN_RULE_FIELDS = ['offerIds', 'storeIds']
    SCAN_RULE_FIELDS.forEach((field) => {
      if (typeof payload.data.scanRule[field] === 'string') {
        payload.data.scanRule[field] = payload.data.scanRule[field].split(',')
      }
    })

    if (moduleAction === 'update-module') {
      if (this.state.currentModuleIndex !== null) {
        payload.data.layout[this.state.currentModuleIndex] = moduleValues
      } else {
        payload.data.layout.push(moduleValues)
      }
    }

    if (moduleAction === 'delete-module') {
      payload.data.layout = payload.data.layout.filter(
        (_, index) => index !== this.state.currentModuleIndex
      )
    }

    if (payload.data.layout.length > 0) {
      payload.data.layout = payload.data.layout.map((module) =>
        formatModuleValues(module, 'form')
      )
    }

    await contentAPIRequestHandler(req, payload, callbacks)
  }

  onCancelModuleForm = () =>
    this.props.router.history.push('/omni-journey/x4u-layout')

  onDeleteModule = () =>
    this._submitHandler(null, this.state.values.isDisabled, 'delete-module')

  render() {
    const tabsItems = ['Mapping', 'Layout', 'Module']
    const isModuleTabDisabled = !this.state.currentModule
    const { popUp, values } = this.state
    const { Form } = this.components

    return (
      <div className="x4u-layout-form">
        <div className="tabs">
          {tabsItems.map((item, index) => {
            const isActive = this.state.activeTab === index
            const isDisabled = index === 2 && isModuleTabDisabled

            return (
              <a
                key={item}
                className={classNames([
                  isActive ? 'active' : '',
                  this.state.activeTab - 1 === index ? 'previous' : '',
                  isDisabled ? 'disabled' : '',
                  'tab',
                ])}
                onClick={() => {
                  if (!isDisabled && this.state.activeTab !== index) {
                    this.handleTabChange(index)
                  }
                }}
                style={{
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  opacity: isDisabled ? 0.5 : 1,
                }}
              >
                {item}
              </a>
            )
          })}
        </div>
        {this.state.isLoading && <Loader />}
        {!this.state.isLoading && (
          <>
            {this.state.activeTab === 0 && (
              <Form>
                <Mapping
                  scanRule={this.state.values.scanRule}
                  generateStateMappers={this.generateStateMappers}
                  onSave={() => this._submitHandler(null, true)}
                  buttons={this.buttons}
                />
              </Form>
            )}
            {this.state.activeTab === 1 && (
              <Layout
                layout={this.state.values.layout || []}
                moveCard={this.moveCard}
                onReset={this.undoLastMove}
                onUpdateLayout={() =>
                  this._submitHandler(null, values.isDisabled)
                }
                canReset={this.state.originalLayout !== null}
                setCurrentModuleIndex={this.setCurrentModuleIndex}
                setCurrentModule={this.setCurrentModule}
                setTab={this.handleTabChange}
                setPopUp={this.setPopUp}
              />
            )}
            {this.state.activeTab === 2 && (
              <ModuleForm
                segment={null}
                hasFilter={false}
                page={APP_PAGES[1]}
                router={this.props.router}
                enableSegmentConfig={false}
                moduleValues={this.state.currentModule}
                moduleType={this.state.currentModule?.mType}
                onSubmitX4ULayoutForm={this._submitHandler}
                onDeleteModule={this.onDeleteModule}
                onCancel={this.onCancelModuleForm}
              />
            )}
            {popUp === 'module-type' && (
              <SelectModuleTypePopup
                setPopUp={this.setPopUp}
                setCurrentModule={this.setCurrentModule}
                setCurrentModuleIndex={this.setCurrentModuleIndex}
                setTab={this.handleTabChange}
              />
            )}
            <ErrorDialog
              message={this.state.errorMessage}
              show={this.state.showErrorDialog}
              onClose={() => {
                this.setState({
                  showErrorDialog: false,
                  errorMessage: null,
                })
                this.handleTabChange(0)
              }}
            />
          </>
        )}
      </div>
    )
  }
}

export default withRouter(({ location, history, match, ...props }) => (
  <X4ULayoutForm router={{ location, history, match }} {...props} />
))
